import { Link } from "react-router-dom";
import { ROUTES } from "../../../lib/constants";

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-dark-primary text-text-primary font-inter">
      {/* Nav */}
      <nav className="border-b border-dark-border/30 bg-dark-primary/90 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to={ROUTES.LANDING} className="text-xl font-black font-outfit tracking-tighter text-golden-accent">
            SuBs
          </Link>
          <Link to={ROUTES.LANDING} className="text-sm text-text-secondary hover:text-golden-accent transition-colors">
            ← Back to Home
          </Link>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="mb-12">
          <p className="text-xs font-semibold uppercase tracking-widest text-golden-accent mb-3">Legal</p>
          <h1 className="text-4xl md:text-5xl font-black font-outfit tracking-tighter text-text-primary mb-4">
            Terms of Service
          </h1>
          <p className="text-text-secondary">Last updated: March 2026</p>
        </div>

        <div className="space-y-10 text-text-secondary leading-relaxed">

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using SuBs ("the Platform"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Platform. These terms apply to all users, including admins, subscribers, and visitors.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">2. Description of Service</h2>
            <p>
              SuBs is a subscription management platform that enables content creators and community managers ("Admins") to manage paid access to their Telegram, Discord, and Slack communities. Users ("Subscribers") pay for access to these communities through the Platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">3. Account Registration</h2>
            <p className="mb-3">
              Admin accounts require registration and verification. You are responsible for:
            </p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activity that occurs under your account</li>
              <li>Notifying us immediately of any unauthorized access</li>
              <li>Providing accurate and up-to-date information during registration</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">4. Payments and Subscriptions</h2>
            <p className="mb-3">
              The Platform processes payments via Razorpay. By subscribing to any community:
            </p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>You authorize the charge for the plan you select</li>
              <li>Subscription fees are non-refundable unless mandated by applicable law</li>
              <li>Access is granted upon successful payment confirmation</li>
              <li>Admins set their own pricing; SuBs is not responsible for pricing disputes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">5. Prohibited Use</h2>
            <p className="mb-3">You may not use SuBs to:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Distribute illegal, harmful, or offensive content</li>
              <li>Engage in fraud, deception, or financial manipulation</li>
              <li>Circumvent payment or access controls</li>
              <li>Violate any applicable laws or third-party platform terms</li>
              <li>Attempt to reverse-engineer or compromise the Platform</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">6. Intellectual Property</h2>
            <p>
              The SuBs platform, branding, and software are proprietary. Content created by Admins remains their property. By using the Platform, Admins grant SuBs a limited license to display and facilitate access to their content as required to operate the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">7. Termination</h2>
            <p>
              We reserve the right to suspend or terminate accounts that violate these terms, engage in fraudulent activity, or cause harm to other users. Subscribers whose admins are terminated will be notified and will not be charged for future periods.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">8. Limitation of Liability</h2>
            <p>
              SuBs is provided "as is." We are not liable for indirect, incidental, or consequential damages arising from your use of the Platform. Our total liability to you shall not exceed the amount you paid us in the three months preceding the claim.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">9. Changes to Terms</h2>
            <p>
              We may update these Terms at any time. Continued use of the Platform after changes constitutes acceptance of the new terms. Material changes will be communicated via email or an in-app notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-text-primary mb-3">10. Contact</h2>
            <p>
              For questions about these Terms, contact us at{" "}
              <Link to={ROUTES.SUPPORT} className="text-golden-accent hover:underline">
                our support page
              </Link>
              .
            </p>
          </section>

        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-dark-border/30 py-8 mt-16">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-text-secondary">
          <p>© {new Date().getFullYear()} SuBs. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to={ROUTES.TERMS} className="hover:text-golden-accent transition-colors">Terms</Link>
            <Link to={ROUTES.PRIVACY} className="hover:text-golden-accent transition-colors">Privacy</Link>
            <Link to={ROUTES.SUPPORT} className="hover:text-golden-accent transition-colors">Support</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
